export default __webpack_public_path__ + "static/media/structured_value_editor.88c69427.png";